const useAuth = () => {
  return (
    localStorage.getItem("premierChefAdminAuthenticated") === "true" &&
    Boolean(localStorage.getItem("premierChefAdminToken"))
  );
};
  
export default useAuth;
  
